import React from 'react';
import { returnColor } from '../../utils/functions';
import './donut.scss';

function Donut({ total, current }) {
  const percent = current / total;
  const color = returnColor(percent);
  return (
    <div
      className="semi-donut-model-2 margin"
      data-deg={(current / total) * 100}
      style={{ '--deg': `${(current / total) * 100}`, '--color': color }}>
      $ {Number(current).toLocaleString()}
    </div>
  );
}

export default Donut;
